import {
  useActiveSubprojectHubFilterCount,
  useSubprojectHubFilterStore,
} from '@/features/projects/subprojects-hub/hooks/subprojects-filter';
import {
  HubFilter,
  HubFilterOption,
} from '@/shared/components/filter/hub-filter';

export const SubprojectHubFilter = () => {
  return (
    <HubFilter
      {...useSubprojectHubFilterStore()}
      activeCount={() => useActiveSubprojectHubFilterCount()}
      options={[
        HubFilterOption.STATUS,
        HubFilterOption.PARTNER,
        HubFilterOption.NOTIFICATION_STATUS,
        HubFilterOption.LAST_ENTRY,
      ].map((option) => ({
        option,
      }))}
    />
  );
};
